import React, { useState } from 'react';
import { CheckIcon, XIcon, StarIcon, LockIcon, ShieldIcon, ZapIcon, SmartphoneIcon, GiftIcon, ClockIcon, ChevronDownIcon, ChevronUpIcon, MailIcon, PawPrintIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-g';
const CTAButton = ({
  label = 'Ja, ik wil Liefdevol Communiceren - voor €127 →',
  className = ''
}: {
  label?: string;
  className?: string;
}) => <a href={CHECKOUT_URL} className={`block w-full md:w-auto md:inline-block bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-4 px-8 rounded-xl text-center transition-colors shadow-lg text-lg ${className}`} data-id="element-2543" data-mp="36l1hlqcn64na">
    {label}
  </a>;
const TrustIcons = () => <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm text-gray-500 mt-4" data-id="element-2544" data-mp="3lazaukpfhkjc">
    <span className="flex items-center gap-1.5" data-id="element-2545" data-mp="3pcaum9lmfbjm">
      <LockIcon className="w-4 h-4" data-id="element-2546" data-mp="3pd40778ufv06" /> Veilig betalen
    </span>
    <span className="flex items-center gap-1.5" data-id="element-2547" data-mp="2u0m8yxjn1ig9">
      <ShieldIcon className="w-4 h-4" data-id="element-2548" data-mp="2u1e4k8d8jg6j" /> 30 dagen garantie
    </span>
    <span className="flex items-center gap-1.5" data-id="element-2549" data-mp="2ozyicczbn3mk">
      <ZapIcon className="w-4 h-4" data-id="element-2550" data-mp="2p3cn1rvgjox6" /> Direct toegang
    </span>
    <span className="flex items-center gap-1.5" data-id="element-2551" data-mp="2k2olwddilrp8">
      <SmartphoneIcon className="w-4 h-4" data-id="element-2552" data-mp="2f2twyfdavc6t" /> Werkt op alle apparaten
    </span>
  </div>;
const Stars = ({
  count = 5
}: {
  count?: number;
}) => <div className="flex gap-0.5" data-id="element-2553" data-mp="3cp9bp9ecdvqo">
    {Array.from({
    length: count
  }).map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-2554" data-mp="37sj0azdhfobl" data-mpi={i} />)}
  </div>;
const TestimonialCard = ({
  quote,
  name,
  stars = 5
}: {
  quote: string;
  name: string;
  stars?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true
}} transition={{
  duration: 0.5
}} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-2555" data-mp="2y153izcx12m5">
    <Stars count={stars} data-id="element-2556" data-mp="1otlbczu1xsvr" />
    <p className="text-gray-700 italic mt-4 mb-4 flex-1 leading-relaxed" data-id="element-2557" data-mp="1trwlzcs687f1">
      "{quote}"
    </p>
    <p className="text-sm font-bold text-[#1a2b4a]" data-id="element-2558" data-mp="1ttplm84d9rdj">- {name}</p>
  </motion.div>;
const PriceBlock = () => <div className="text-center mb-6" data-id="element-2559" data-mp="1k239m9k7fo9q">
    <p className="text-gray-500 text-lg line-through mb-1" data-id="element-2560" data-mp="1k11otdddznet">
      Totale waarde: €223,90
    </p>
    <p className="text-4xl md:text-5xl font-black text-[#1a2b4a]" data-id="element-2561" data-mp="1618y3i1v176u">
      Nu slechts €127
    </p>
    <p className="text-gray-600 mt-1" data-id="element-2562" data-mp="1a4yl432vzgpr">Eenmalige betaling</p>
  </div>;
const FAQItem = ({
  q,
  a
}: {
  q: string;
  a: string;
}) => {
  const [open, setOpen] = useState(false);
  return <div className="border-b border-gray-200" data-id="element-2563" data-mp="112pdbkz061g2">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between py-5 text-left" data-id="element-2564" data-mp="113h7crcybr48">
        <span className="font-bold text-[#1a2b4a] text-lg pr-4" data-id="element-2565" data-mp="2vh02jujiexmd">{q}</span>
        {open ? <ChevronUpIcon className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-2566" data-mp="jtwluoalycx7" /> : <ChevronDownIcon className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-2567" data-mp="jrk6miw8ignu" />}
      </button>
      {open && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} className="pb-5 text-gray-600 leading-relaxed" data-id="element-2568" data-mp="tjg5hw65aat4">
          {a}
        </motion.div>}
    </div>;
};
export function LiefdevolCommunicerenCursusPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-2569" data-mp="xnnsnowyfip8">
      {/* SECTION 1: STICKY TOP BAR */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#e6f7f5] border-t border-[#5ce0d2]/30 py-2.5 px-4" data-id="element-2570" data-mp="17jhey00h6qk7">
        <div className="max-w-6xl mx-auto flex items-center justify-center gap-2 text-sm md:text-base" data-id="element-2571" data-mp="3e9nodrzr5f4a">
          <span className="text-[#1a2b4a]" data-id="element-2572" data-mp="39bdnr1v9dmba">
            🐾 Tijdelijke aanbieding:{' '}
            <span className="line-through" data-id="element-2573" data-mp="20e5rasn5fzv8">€223,90</span> -{' '}
            <strong data-id="element-2574" data-mp="20dnk50yy818j">Nu slechts €127</strong>
          </span>
          <a href="#bestellen" className="text-[#1a2b4a] font-bold underline hover:text-[#5ce0d2] transition-colors ml-2 whitespace-nowrap" data-id="element-2575" data-mp="25c7816x3rn3j">
            Ja, ik wil beginnen →
          </a>
        </div>
      </div>

      {/* SECTION 2: HEADER */}
      <div className="pt-12" data-id="element-2576" data-mp="1hnxuesa1m5nh">
        <nav className="border-b border-gray-100 py-4 px-4 bg-white" data-id="element-2577" data-mp="1hopd52ijk8wc">
          <div className="flex justify-center md:justify-between items-center max-w-6xl mx-auto" data-id="element-2578" data-mp="1mlzdhd7gy4yy">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-2579" data-mp="1qnkjcell5izn" />
            <a href="mailto:amee@stresslessdogs.nl" className="hidden md:flex items-center text-sm font-medium text-gray-500 hover:text-[#5ce0d2] transition-colors" data-id="element-2580" data-mp="ywo6vf3ftgcw">
              <MailIcon className="w-4 h-4 mr-2" data-id="element-2581" data-mp="vcwgli3a6dbh" />
              Hulp nodig? Mail mij op amee@stresslessdogs.nl
            </a>
          </div>
        </nav>
      </div>

      {/* SECTION 2: HERO */}
      <section className="max-w-6xl mx-auto px-5 py-12 md:py-20" data-id="element-2582" data-mp="mchjzmkv9bso">
        <div className="grid md:grid-cols-12 gap-10 items-center" data-id="element-2583" data-mp="he69d9mqyx9e">
          <div className="md:col-span-7 order-2 md:order-1" data-id="element-2584" data-mp="cfuz4xsjikqn">
            <p className="text-sm italic text-[#5ce0d2] mb-3" data-id="element-2585" data-mp="chfv8rui6bqm">
              Speciaal voor liefdevolle hondeneigenaren:
            </p>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#1a2b4a] mb-5 leading-tight" data-id="element-2586" data-mp="2q1xaoi79jzl">
              Je hond wil wél luisteren.
              <br data-id="element-2587" data-mp="3uvp39arrwyhp" />
              Hij begrijpt je gewoon niet.
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-6 leading-relaxed" data-id="element-2588" data-mp="3ptzp3m9984pe">
              Ontdek de verborgen taalbarrière die voorkomt dat jullie écht op
              één lijn zitten - en hoe je die doorbreekt zonder te straffen, te
              commanderen of te domineren.
            </p>
            <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500 mb-8" data-id="element-2589" data-mp="3g8gibi8nxesj">
              <span className="flex items-center gap-1" data-id="element-2590" data-mp="31axuqj7q17mo">
                <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-2591" data-mp="31ciq2b1v0ull" />
                <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-2592" data-mp="369hj0q9sevi7" />
                <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-2593" data-mp="3tzbxfc9r8s4k" />
                <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-2594" data-mp="2rh935ko8g1y" />{' '}
                4,3 op Trustpilot
              </span>
              <span data-id="element-2595" data-mp="3k6xtqdz49bfr">🐾 15.000+ honden geholpen</span>
              <span className="flex items-center gap-1" data-id="element-2596" data-mp="3p7bpoxng0uxf">
                <CheckIcon className="w-4 h-4 text-green-500" data-id="element-2597" data-mp="3p5qxheolpo2q" /> 1054+
                beoordelingen
              </span>
            </div>
            <CTAButton label="Ja, ik wil de Hondentaal leren spreken - voor slechts €127 →" data-id="element-2598" data-mp="lja22zzqq19o" />
            <p className="text-xs text-gray-400 mt-3" data-id="element-2599" data-mp="268vw7siup9og">
              30 dagen niet-goed-geld-terug garantie · Direct toegang ·
              Eenmalige betaling
            </p>
          </div>
          <div className="md:col-span-5 order-1 md:order-2" data-id="element-2600" data-mp="2fyyyykfry1zz">
            <div className="rounded-2xl overflow-hidden shadow-lg" data-id="element-2601" data-mp="2g1bg4vdpk8bz">
              <img src="https://cdn.magicpatterns.com/uploads/vZLarCb4ynRSjgCisN7z8e/freepik_middelgrote-hond-in-een-g_2777443833.png" alt="Vrouw met hond in een ontspannen setting" className="w-full h-auto object-cover" data-id="element-2602" data-mp="2b1gqsw9kzqt1" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3: EMPATHY & RECOGNITION */}
      <section className="bg-[#faf5eb] py-16 md:py-20 px-5" data-id="element-2603" data-mp="1s8l4kn9pvr28">
        <div className="max-w-2xl mx-auto text-lg text-gray-700 leading-relaxed space-y-5" data-id="element-2604" data-mp="37qeoam8pu2tw">
          <p className="text-2xl font-bold text-[#1a2b4a]" data-id="element-2605" data-mp="33otej9rha4nx">
            Mag ik je iets eerlijks vragen?
          </p>
          <p data-id="element-2606" data-mp="112o0ahdd9jf8">
            Je houdt van je hond. Echt. Je geeft hem de beste voeding, lange
            wandelingen, een warme plek op de bank. Je hebt misschien al van
            alles geprobeerd - cursussen, tips van trainers, YouTube-video's.
          </p>
          <p data-id="element-2607" data-mp="1ay8w1xrudngj">En toch…</p>
          <p data-id="element-2608" data-mp="1fr23wuilxbwu">
            Toch is er die wandeling waarbij je hart een beetje sneller klopt
            als je een andere hond ziet aankomen.
          </p>
          <p data-id="element-2609" data-mp="1js40f3l539v4">
            Toch is er dat moment als de deurbel gaat en je al weet wat er gaat
            gebeuren.
          </p>
          <p data-id="element-2610" data-mp="1otjpr7uco2jb">
            Toch is er dat gevoel van:{' '}
            <em data-id="element-2611" data-mp="1ts4ot3xv8g66">"Waarom luistert hij nou niet? Ik doe toch alles goed?"</em>
          </p>
          <p data-id="element-2612" data-mp="1yov59sdl1ds4">
            Dat gevoel kent bijna elke hondeneigenaar. En het heeft niets te
            maken met hoe goed jij je best doet.
          </p>
          <p className="font-bold text-[#1a2b4a]" data-id="element-2613" data-mp="4bvjtimitpcx">
            Het heeft alles te maken met communicatie.
          </p>
        </div>
      </section>

      {/* SECTION 4: THE PROBLEM */}
      <section className="py-16 md:py-20 px-5" data-id="element-2614" data-mp="2ho9c3nanfxkm">
        <div className="max-w-2xl mx-auto" data-id="element-2615" data-mp="2cv6m1p52z696">
          <h2 className="text-3xl font-bold text-[#5ce0d2] text-center mb-8" data-id="element-2616" data-mp="2ctbys46c721x">
            Waarom de taalbarrière tussen jou en je hond alles verandert
          </h2>
          <div className="text-lg text-gray-700 leading-relaxed space-y-5 mb-10" data-id="element-2617" data-mp="23w1ksb24wytb">
            <p data-id="element-2618" data-mp="30lanbpusqtx0">
              Jij communiceert de hele dag met je hond. Met je stem, je woorden,
              je handen. Dat is hoe mensen van nature communiceren.
            </p>
            <p data-id="element-2619" data-mp="2rk2rrfjo076m">
              Maar je hond communiceert via lichaamstaal, energie en beweging.
              Dat is zijn moedertaal. De taal die hij al zijn hele leven
              vloeiend spreekt.
            </p>
            <p data-id="element-2620" data-mp="1g5fofh1ht2z5">
              Het is alsof jij de hele dag in het Nederlands praat tegen iemand
              die alleen Spaans spreekt. Hij snapt de toon, hij voelt de emotie
              - maar de boodschap komt maar voor een deel aan.
            </p>
          </div>

          {/* Comparison Card */}
          <div className="grid md:grid-cols-2 gap-4 mb-10" data-id="element-2621" data-mp="d805t0paexb3">
            <div className="bg-[#faf5eb] rounded-2xl p-6 border border-gray-100" data-id="element-2622" data-mp="rvuxqevh0xn4">
              <p className="font-bold text-[#1a2b4a] mb-4 text-lg" data-id="element-2623" data-mp="rxxzfw5zkf7o">
                🗣️ Hoe mensen communiceren
              </p>
              <ul className="space-y-2 text-gray-700" data-id="element-2624" data-mp="10w9p9vz138z2">
                <li data-id="element-2625" data-mp="10uot61x2fhz3">Stem en woorden</li>
                <li data-id="element-2626" data-mp="vxouwd6gjjij">Handen en gebaren</li>
                <li data-id="element-2627" data-mp="vwnbnlfafqpq">Verbale instructies</li>
                <li data-id="element-2628" data-mp="1aupcvoyuk03t">Emotionele toon</li>
              </ul>
            </div>
            <div className="bg-[#e6f7f5] rounded-2xl p-6 border border-[#5ce0d2]/20" data-id="element-2629" data-mp="1asmqrg0ter4d">
              <p className="font-bold text-[#1a2b4a] mb-4 text-lg" data-id="element-2630" data-mp="15w5u1xfjv4fo">
                🐾 Hoe honden communiceren
              </p>
              <ul className="space-y-2 text-gray-700" data-id="element-2631" data-mp="3cnx15nwfts1u">
                <li data-id="element-2632" data-mp="37oap3hscihum">Lichaamstaal</li>
                <li data-id="element-2633" data-mp="37pc1pqp0fceg">Energie en beweging</li>
                <li data-id="element-2634" data-mp="1n4ovx7mtantd">Subtiele signalen</li>
                <li data-id="element-2635" data-mp="1n71kw4qzlyfx">Lichaamshouding</li>
              </ul>
            </div>
          </div>

          <div className="text-lg text-gray-700 leading-relaxed space-y-5" data-id="element-2636" data-mp="1s38fx2huhpj3">
            <p data-id="element-2637" data-mp="1decald76aqm6">
              Dit is <strong data-id="element-2638" data-mp="1devjy5irc6ol">Het Mensentaal Probleem</strong> - en het is de
              echte reden waarom commando's niet landen, waarom je hond soms
              doet alsof hij je niet hoort, en waarom die diepe verbinding die
              je voelt dat er moet zijn… er nog niet helemaal is.
            </p>
            <p data-id="element-2639" data-mp="18dxztne6t2kg">
              Dit heeft niets te maken met hoe slim je hond is. Niets met hoe
              hard je je best doet.{' '}
              <strong data-id="element-2640" data-mp="zeuh4kixmp6h">Het heeft alles te maken met communicatie.</strong>
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 5: WHAT DOESN'T WORK */}
      <section className="bg-[#faf5eb] py-16 md:py-20 px-5" data-id="element-2641" data-mp="2oshjmkm8tqod">
        <div className="max-w-2xl mx-auto" data-id="element-2642" data-mp="2ts2dwhqgxaur">
          <h2 className="text-3xl font-bold text-[#1a2b4a] text-center mb-10" data-id="element-2643" data-mp="2sc87pgz0nca2">
            Waarom de meeste aanpakken niet werken
          </h2>
          <div className="space-y-5 mb-10" data-id="element-2644" data-mp="2ncc1db2uj8rc">
            {[{
            title: 'Streng zijn en "de baas spelen"',
            desc: 'De hond wordt er alleen maar nerveuzer van - en de band wordt slechter, niet beter.'
          }, {
            title: 'Commando\'s herhalen ("Zit! Zit! Zit!")',
            desc: 'Hij hoort je wel, maar begrijpt de boodschap niet volledig in jouw taal.'
          }, {
            title: 'Hondenschool met groepslessen',
            desc: 'In een drukke ruimte is je hond zo overprikkeld dat hij niets opneemt.'
          }, {
            title: 'Privétrainer die "dominantie" predikt',
            desc: 'Na de sessies gaat alles weer precies hetzelfde - omdat de communicatie niet veranderd is.'
          }, {
            title: "Tips van vrienden en YouTube-video's",
            desc: 'Wat bij hun hond werkt, werkt bij de jouwe niet - want elke hond en elk baasje is anders.'
          }].map((item, i) => <div key={i} className="bg-white rounded-xl p-5 border border-gray-100 flex items-start gap-4" data-id="element-2645" data-mp="a5nkl3u6coem" data-mpi={i}>
                <XIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-2646" data-mp="k4uvzlhcm8z3" />
                <div data-id="element-2647" data-mp="k2s8b83o4rxj">
                  <p className="font-bold text-[#1a2b4a] mb-1" data-id="element-2648" data-mp="o5yd0bb4ub1w">{item.title}</p>
                  <p className="text-gray-600" data-id="element-2649" data-mp="o3tyz0jirvnw">{item.desc}</p>
                </div>
              </div>)}
          </div>
          <p className="text-xl font-bold text-[#1a2b4a] text-center leading-relaxed" data-id="element-2650" data-mp="xwjatwizfbjr">
            Al deze aanpakken proberen je hond jóuw taal te leren.
            <br data-id="element-2651" data-mp="12szwmk2pldto" />
            Maar dat werkt niet. De oplossing is precies andersom.
          </p>
        </div>
      </section>

      {/* SECTION 6: AMEE'S STORY */}
      <section className="py-16 md:py-20 px-5" data-id="element-2652" data-mp="24k9jmohr8696">
        <div className="max-w-6xl mx-auto" data-id="element-2653" data-mp="1zmhgeybnsxpo">
          <h2 className="text-3xl font-bold text-[#1a2b4a] text-center mb-12" data-id="element-2654" data-mp="1zlg6wyaakja2">
            Hoe ik ontdekte dat alles wat ik geleerd had… niet klopte
          </h2>
          <div className="grid md:grid-cols-12 gap-10 items-start" data-id="element-2655" data-mp="29cj4vr7xci54">
            <div className="md:col-span-7 text-lg text-gray-700 leading-relaxed space-y-5" data-id="element-2656" data-mp="29eds5c6o4mcd">
              <p data-id="element-2657" data-mp="1lmyjz2s7nat7">
                Mijn naam is Amee de Bruijn, en ik schaam me eerlijk gezegd een
                beetje als ik terugdenk aan hoe ik vroeger met honden omging.
              </p>
              <p data-id="element-2658" data-mp="1uoppo7mr3hn2">
                Ik studeerde voor hondengedragsconsultant. Ik leerde alles wat
                er te leren viel. En wat me geleerd werd, was: wees de baas.
                Wees dominant. Honden zijn afstammelingen van wolven, dus je
                moet de alfawolf zijn.
              </p>
              <p data-id="element-2659" data-mp="320ona7bi9v1s">
                Ik deed het. Ik probeerde het. En ik voelde me er vreselijk bij.
              </p>
              <p data-id="element-2660" data-mp="39mtxpxr5oyji">
                Want ik hield van honden. Echt. En dan moest ik ze behandelen
                alsof het robots waren - alsof je op de juiste knopjes moest
                drukken en dan zouden ze gehoorzamen.
              </p>
              <p data-id="element-2661" data-mp="34mfpaeln7mky">Totdat ik iets ontdekte wat alles veranderde.</p>
              <p data-id="element-2662" data-mp="3sb8oql1h4ckb">
                Ik leerde dat honden in het wild helemaal geen duidelijke
                "alfaleider" hebben. Ze leven meer als een gezin. Ze
                communiceren. Ze houden rekening met elkaar. Ze lezen elkaars
                lichaamstaal met een precisie die wij mensen ons nauwelijks
                kunnen voorstellen.
              </p>
              <p data-id="element-2663" data-mp="3ni5sg55bap0f">
                Mijn mentor in deze ontdekking was <strong data-id="element-2664" data-mp="f46w32efh1me">Turid Rugaas</strong>
                , een Noorse hondengedragsdeskundige die de wereld van
                hondencommunicatie letterlijk op zijn kop heeft gezet. Zij
                ontdekte de "calming signals" - de subtiele lichaamstaalsignalen
                waarmee honden de hele dag met elkaar communiceren.
              </p>
              <p data-id="element-2665" data-mp="oq86wp7xba1q">
                Toen ik haar werk leerde kennen, viel alles op zijn plek. Ik
                begon honden te benaderen in hun eigen taal. En wat er toen
                gebeurde… dat vergeet ik nooit meer.
              </p>
              <p data-id="element-2666" data-mp="asjix8ik7msg">
                Honden die al jaren gedragsproblemen hadden - honden waar geen
                enkele trainer iets mee kon - die werden rustiger. Opener. Ze
                zochten toenadering in plaats van te vluchten.
              </p>
              <p data-id="element-2667" data-mp="1042wgqtp8a7">
                En de baasjes? Die zeiden steeds hetzelfde:{' '}
                <em data-id="element-2668" data-mp="3t83upr99zhan">
                  "Ik begrijp mijn hond nu eindelijk. Ik kijk anders naar hem.
                  Ik voel dat we écht contact hebben."
                </em>
              </p>
            </div>
            <div className="md:col-span-5" data-id="element-2669" data-mp="3ja681872dsk5">
              <div className="sticky top-24" data-id="element-2670" data-mp="1yqu24dv6xrkw">
                <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee de Bruijn met haar hond" className="w-full rounded-2xl shadow-lg" data-id="element-2671" data-mp="1ys58mlg0tdfp" />
              </div>
            </div>
          </div>
          <div className="max-w-3xl mx-auto mt-12" data-id="element-2672" data-mp="1fzjimhrsoh31">
            <blockquote className="text-2xl md:text-3xl font-bold text-[#5ce0d2] text-center italic leading-snug" data-id="element-2673" data-mp="1g14b81ujtpy9">
              "Honden hebben geen baas nodig. Ze hebben een ouder nodig. Iemand
              die hun taal spreekt."
            </blockquote>
            <p className="text-center text-gray-500 mt-3" data-id="element-2674" data-mp="1tqpp4xthrezf">- Amee de Bruijn</p>
          </div>
        </div>
      </section>

      {/* SECTION 7: FIRST TESTIMONIALS */}
      <section className="bg-[#faf5eb] py-16 md:py-20 px-5" data-id="element-2675" data-mp="x6z1fxlgk0f2">
        <div className="max-w-5xl mx-auto" data-id="element-2676" data-mp="119lozmb3iz6g">
          <h2 className="text-3xl font-bold text-[#1a2b4a] text-center mb-12" data-id="element-2677" data-mp="118aktldqnpet">
            Wat hondeneigenaren zeggen nadat ze de Hondentaal leerden spreken
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-2678" data-mp="3lv6xvr1pzyv2">
            <TestimonialCard quote="De cursus liefdevol communiceren met je hond is echt een eyeopener en de communicatie lichaamstaal werkt super goed. Mijn hond begrijpt het meteen." name="Cursist Liefdevol Communiceren" data-id="element-2679" data-mp="4m1s7fccxb9r" />
            <TestimonialCard quote="Ik kijk nu ook echt anders naar mijn hond. Waar ik dacht vooral een angstige hond te hebben, blijkt zij gewoon heel beleefd te zijn. Mijn benadering naar haar toe is daardoor anders." name="Cursist Liefdevol Communiceren" data-id="element-2680" data-mp="dju74ie62gwm" />
            <TestimonialCard quote="Echt helemaal WOW!!! Ik was ten einde raad! Ik had al veel geprobeerd, veel raad gekregen en heel veel geld uitgegeven. Aïko is super blij met de 'taakjes' die hij nu krijgt en wij zijn blij dat we hem eindelijk rustig kregen!" name="Inge Vercammen" data-id="element-2681" data-mp="if9i92kshypc" />
            <TestimonialCard quote="Ook al dachten we al veel te weten na 12 jaar een Golden Retriever gehad te hebben, was het toch nog erg leerzaam. Je merkt nu pas hoeveel je uitgaat van het praten in plaats van lichaamstaal." name="Cursist met 12 jaar hondenervaring" data-id="element-2682" data-mp="1fyzzlptp26h3" />
          </div>
        </div>
      </section>

      {/* SECTION 8: PRODUCT REVEAL */}
      <section className="py-16 md:py-20 px-5" data-id="element-2683" data-mp="wzccxcjjcah7">
        <div className="max-w-3xl mx-auto text-center" data-id="element-2684" data-mp="x16ymt2ms6mc">
          <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] mb-6" data-id="element-2685" data-mp="j8qyq1510opn">
            Introduceer: De Liefdevol Communiceren Cursus
          </h2>
          <div className="mb-8" data-id="element-2686" data-mp="n7q23hb40dez">
            <img src="https://cdn.magicpatterns.com/uploads/d7mvv6jB1XyRHfPv1QLUbd/Verlatingangst_kernmethode_bonus_(2).png" alt="Liefdevol Communiceren Cursus" className="w-full max-w-md mx-auto" data-id="element-2687" data-mp="9ab9k3pk7pis" />
          </div>
          <div className="text-lg text-gray-700 leading-relaxed space-y-5 text-left max-w-2xl mx-auto" data-id="element-2688" data-mp="dftr4x3u1696">
            <p data-id="element-2689" data-mp="hczieigj9ij4">
              De Liefdevol Communiceren cursus is een complete online cursus van{' '}
              <strong data-id="element-2690" data-mp="3hw42cxplfi5">7 modules</strong> waarin je stap voor stap leert
              communiceren in hondentaal.
            </p>
            <p data-id="element-2691" data-mp="w3oxhvx47hs9">
              Geen dominantie. Geen straffen. Geen commando's herhalen tot je er
              moe van wordt.
            </p>
            <p data-id="element-2692" data-mp="112s59o4hc23x">
              Alleen: <strong data-id="element-2693" data-mp="1154ixp37fqb6">de echte taal van je hond leren spreken.</strong>{' '}
              Zodat jullie eindelijk écht op één lijn zitten.
            </p>
            <p data-id="element-2694" data-mp="rcgov23m00g5">
              Je hond hoeft niets nieuws te leren. Hij spreekt deze taal al zijn
              hele leven.{' '}
              <strong data-id="element-2695" data-mp="1f1rscrccg8xz">
                Jij leert zijn taal spreken - en dan begrijpt hij je gewoon.
              </strong>
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 9: SECOND CTA */}
      <section className="bg-[#e6f7f5] py-16 md:py-20 px-5" id="bestellen" data-id="element-2696" data-mp="34hvgj9neomyd">
        <div className="max-w-xl mx-auto text-center" data-id="element-2697" data-mp="2zkv8it6zxa4m">
          <div className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-2 text-sm font-medium text-[#1a2b4a] mb-6 shadow-sm" data-id="element-2698" data-mp="3dcrwqm5jmzvq">
            <ClockIcon className="w-4 h-4" data-id="element-2699" data-mp="39bq6gutlty5w" /> Tijdelijke kortingsactie - Niet
            permanent beschikbaar
          </div>
          <PriceBlock data-id="element-2700" data-mp="2gm969azqtcz4" />
          <CTAButton data-id="element-2701" data-mp="2gmso6rpe81d5" />
          <TrustIcons data-id="element-2702" data-mp="2gnaru9edxhv3" />
        </div>
      </section>

      {/* SECTION 10: WHAT'S INCLUDED */}
      <section className="py-16 md:py-20 px-5" data-id="element-2703" data-mp="2un3ffvum7hyu">
        <div className="max-w-3xl mx-auto" data-id="element-2704" data-mp="2ujo1wxglagzj">
          <h2 className="text-3xl font-bold text-[#1a2b4a] text-center mb-12" data-id="element-2705" data-mp="2plw9m2c18sut">
            Dit is alles wat je krijgt voor slechts €127
          </h2>

          {/* Module Timeline */}
          <div className="space-y-6 mb-16" data-id="element-2706" data-mp="4x8ai73aihq6">
            {[{
            step: 1,
            title: 'Tools voor het dagelijks leven',
            value: '€49,95',
            desc: 'Je leert de kalmerende signalen die honden gebruiken om spanning te verminderen - en hoe jij ze zelf kunt inzetten. Hiermee doorbreek je miscommunicatie voordat die escaleert.'
          }, {
            step: 2,
            title: 'Omgangsregels',
            value: '€37',
            desc: 'Wat jij misschien ziet als "brutaal" gedrag, is vaak gewoon je hond die beleefd probeert te zijn op zijn eigen manier. Je leert die subtiele signalen herkennen en respecteren.'
          }, {
            step: 3,
            title: 'Tafelmanieren',
            value: '€17',
            desc: 'Leer hoe je impulscontrole opbouwt op een positieve manier - zodat opspringen bij bezoek en eten van tafel pakken tot het verleden behoren.'
          }, {
            step: 4,
            title: 'Jouw Reactie',
            value: '€24,95',
            desc: 'Wetenschappelijk bewezen: honden synchroniseren hun stressniveau met dat van hun baasje. In deze module leer je hoe je zelf rustiger wordt - en hoe dat direct effect heeft op je hond.'
          }, {
            step: 5,
            title: 'Het Handsignaal',
            value: '€22',
            desc: 'Honden begrijpen handgebaren van nature beter dan woorden. Leer hoe je grenzen stelt zonder te schreeuwen - met één rustig gebaar.'
          }, {
            step: 6,
            title: 'Het Attentiesignaal',
            value: '€22',
            desc: 'De allerbelangrijkste vaardigheid: eerst de aandacht van je hond pakken, dán communiceren. Dit voorkomt uitvallen en geeft je hond de zekerheid dat jij er voor hem bent.'
          }, {
            step: 7,
            title: 'Stressreductie',
            value: '€22',
            desc: 'Liefdevol communiceren verlaagt letterlijk het stressniveau van je hond. Leer hoe snuffelen, samen ontspannen en contact maken de hormoonbalans van je hond herstelt.'
          }].map((mod, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.05
          }} className="flex gap-5 items-start" data-id="element-2707" data-mp="2dd9ioj8lnhci" data-mpi={i}>
                <div className="w-12 h-12 rounded-full bg-[#5ce0d2] text-white flex items-center justify-center font-black text-lg flex-shrink-0 mt-1" data-id="element-2708" data-mp="1zg49499og0ci">
                  {mod.step}
                </div>
                <div className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm flex-1" data-id="element-2709" data-mp="3tpoog5p1lq2f">
                  <div className="flex items-start justify-between mb-2" data-id="element-2710" data-mp="7o7j09j9npwl">
                    <h4 className="font-bold text-[#1a2b4a] text-lg" data-id="element-2711" data-mp="2t1ztih90pc7">
                      Module {mod.step}: {mod.title}
                    </h4>
                    <span className="text-xs bg-[#e6f7f5] text-[#1a2b4a] font-bold px-2.5 py-1 rounded-full whitespace-nowrap ml-3" data-id="element-2712" data-mp="bsf9ab5dhdwx">
                      Waarde: {mod.value}
                    </span>
                  </div>
                  <p className="text-gray-600 leading-relaxed" data-id="element-2713" data-mp="lgx66haj70va">{mod.desc}</p>
                </div>
              </motion.div>)}
          </div>

          {/* Bonuses */}
          <h3 className="text-2xl font-bold text-[#1a2b4a] text-center mb-8" data-id="element-2714" data-mp="vfmqegpwgxep">
            En daarnaast ontvang je ook nog:
          </h3>
          <div className="grid md:grid-cols-3 gap-5 mb-12" data-id="element-2715" data-mp="319moba09yw9j">
            {[{
            icon: '🎁',
            title: 'Masterclass "Honden Geschiedenis"',
            desc: 'Begrijp waar je hond vandaan komt - en waarom hij doet wat hij doet.',
            value: '€7'
          }, {
            icon: '🎁',
            title: '8 Printbare Stappenplannen',
            desc: 'Voor elke communicatievaardigheid een overzichtelijk, printbaar stappenplan. Hang ze op de koelkast of neem ze mee op wandeling.',
            value: '€44'
          }, {
            icon: '🎁',
            title: 'Levenslange, onbeperkte toegang',
            desc: 'De cursus verdwijnt nooit. Kijk altijd terug, herhaal, en ontdek nieuwe dingen naarmate je hond groeit.',
            value: 'Onbetaalbaar'
          }].map((bonus, i) => <div key={i} className="bg-[#faf5eb] rounded-xl p-5 border border-gray-100" data-id="element-2716" data-mp="22tqg1ipp1cyc" data-mpi={i}>
                <p className="text-2xl mb-3" data-id="element-2717" data-mp="26wd9fo20j5xn">{bonus.icon}</p>
                <h4 className="font-bold text-[#1a2b4a] mb-2" data-id="element-2718" data-mp="3rde4nkadd46f">{bonus.title}</h4>
                <p className="text-sm text-gray-600 mb-3" data-id="element-2719" data-mp="3rb9q88eugmrw">{bonus.desc}</p>
                <span className="text-xs bg-white text-[#1a2b4a] font-bold px-2.5 py-1 rounded-full" data-id="element-2720" data-mp="3na7p1m1da0na">
                  Waarde: {bonus.value}
                </span>
              </div>)}
          </div>

          {/* Value Summary */}
          <div className="bg-[#e6f7f5] rounded-2xl p-8 text-center border border-[#5ce0d2]/20" data-id="element-2721" data-mp="evzb9k3i7ef6">
            <p className="text-gray-600 text-lg line-through mb-1" data-id="element-2722" data-mp="9ww67znix877">
              Totale waarde: €223,90
            </p>
            <p className="text-3xl font-black text-[#1a2b4a]" data-id="element-2723" data-mp="55mn7hwhd34a">
              Jouw investering vandaag: €127 eenmalig
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 11: THIRD CTA */}
      <section className="bg-[#e6f7f5] py-16 md:py-20 px-5" data-id="element-2724" data-mp="xniffu99kyis">
        <div className="max-w-xl mx-auto text-center" data-id="element-2725" data-mp="svqohim74qs4">
          <PriceBlock data-id="element-2726" data-mp="su5txszvt7u9" />
          <CTAButton data-id="element-2727" data-mp="stnqocesxtcu" />
          <TrustIcons data-id="element-2728" data-mp="18fjrznhsb8t" />
        </div>
      </section>

      {/* SECTION 12: MORE TESTIMONIALS */}
      <section className="py-16 md:py-20 px-5" data-id="element-2729" data-mp="5ym4hoevvbls">
        <div className="max-w-6xl mx-auto" data-id="element-2730" data-mp="60gqz75szbrz">
          <h2 className="text-3xl font-bold text-[#1a2b4a] text-center mb-12" data-id="element-2731" data-mp="3ocvg0hbd4ghm">
            Meer dan 15.000 honden en baasjes gingen je al voor
          </h2>
          <div className="grid md:grid-cols-3 gap-6 mb-10" data-id="element-2732" data-mp="3sf030x7b2eva">
            <TestimonialCard quote="Ik ben heel gelukkig met de online cursus. Je leert je hond te begrijpen en leert anders naar je hond te kijken op een hele fijne manier. Voor mens en hond!" name="Uschi Haase" data-id="element-2733" data-mp="jy5eynv62z19" />
            <TestimonialCard quote="Fijne info en brengt rust in de opvoeding." name="Hellen Kleijberg, baasje van Mika en Moos" data-id="element-2734" data-mp="b035djxday2d" />
            <TestimonialCard quote="Heel leerzaam om je hond te begrijpen. Raad het elke hondenbezitter aan!" name="C. en T. Swagerman" data-id="element-2735" data-mp="2vnepxqb7tbok" />
            <TestimonialCard quote="Mijn hond Floris en ik vinden de oefeningen leuk. En Floris is een stuk rustiger geworden sinds wij regelmatig oefenen." name="Anneke Petersen, baasje van Floris" data-id="element-2736" data-mp="2s5ikg1m8r63s" />
            <TestimonialCard quote="Wij hebben een zeer overprikkelde hond en met de cursus liefdevol communiceren kregen we al waardevolle tips om de rust in huis te laten terugkeren." name="Cursist Liefdevol Communiceren" data-id="element-2737" data-mp="323okedohm260" />
            <TestimonialCard quote="Ik heb eindelijk het idee dat ik niet gek ben hoe ik mijn hond wil opvoeden. Ik wist alleen niet goed hoe. Gelukkig weet ik meer nu." name="Cursist Liefdevol Communiceren" data-id="element-2738" data-mp="24hqz68iq3iqd" />
          </div>
          <div className="flex items-center justify-center gap-2 text-gray-500" data-id="element-2739" data-mp="1qpaz9gl4c0to">
            <StarIcon className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-2740" data-mp="1qmyaajgy0q74" />
            <StarIcon className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-2741" data-mp="1lpomt9d46olx" />
            <StarIcon className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-2742" data-mp="jr8u0uakhzfv" />
            <StarIcon className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-2743" data-mp="eyyzf0yicb79" />
            <span className="ml-2 font-medium" data-id="element-2744" data-mp="a0dwuuvs9ffn">
              4,3 / 5 op Trustpilot · 1054+ beoordelingen
            </span>
          </div>
        </div>
      </section>

      {/* SECTION 13: ABOUT AMEE */}
      <section className="bg-[#faf5eb] py-16 md:py-20 px-5" data-id="element-2745" data-mp="12p1kuy7x2iww">
        <div className="max-w-5xl mx-auto" data-id="element-2746" data-mp="12oa3arb5mlpm">
          <h2 className="text-3xl font-bold text-[#1a2b4a] text-center mb-12" data-id="element-2747" data-mp="xq8avfru9a1h">
            Over Amee van Stressless Dogs
          </h2>
          <div className="grid md:grid-cols-12 gap-10 items-start" data-id="element-2748" data-mp="spkj2rvscp67">
            <div className="md:col-span-5" data-id="element-2749" data-mp="optkw33xj6rn">
              <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee de Bruijn" className="w-full rounded-2xl shadow-lg" data-id="element-2750" data-mp="ooqz29lgruil" />
            </div>
            <div className="md:col-span-7" data-id="element-2751" data-mp="1oy9tkxjprz30">
              <blockquote className="text-xl italic text-[#5ce0d2] mb-6 leading-relaxed" data-id="element-2752" data-mp="1ovduh5w4r4cz">
                "Goed en liefdevol communiceren kun je leren - en het is de
                sleutel tot een leuk en probleemloos leven samen met je hond."
              </blockquote>
              <div className="text-gray-700 leading-relaxed space-y-4" data-id="element-2753" data-mp="22pn8tzalaas8">
                <p data-id="element-2754" data-mp="27ohtz7w14bfi">
                  Ik ben een gediplomeerd hondengedragsconsultant en Natural Dog
                  Trainer (niveau 5), opgeleid bij Calming Signs in Koningslust.
                  Ik werk uitsluitend met methodes die vrij zijn van dwang,
                  pijn, angst en straf.
                </p>
                <p data-id="element-2755" data-mp="2lmohpv79kv1g">
                  In mijn werk staan altijd vier thema's centraal: vertrouwen,
                  veiligheid, wederzijds respect en communicatie.
                </p>
                <p data-id="element-2756" data-mp="r8wzw8es74ux">
                  Inmiddels heb ik meer dan 15.000 honden en hun baasjes mogen
                  helpen. Niet door ze te vertellen wat ze fout doen - maar door
                  ze te laten zien hoe ze in de taal van hun hond kunnen
                  communiceren.
                </p>
                <p className="font-bold text-[#1a2b4a]" data-id="element-2757" data-mp="23lkbk2wgfg0l">
                  Jij bent al een goed baasje. Je hebt alleen de juiste taal nog
                  niet geleerd.
                </p>
              </div>
              <div className="flex flex-wrap gap-4 mt-6 text-sm text-gray-500" data-id="element-2758" data-mp="2digfrwfblfzc">
                <span data-id="element-2759" data-mp="28l6r4izr98ck">🎓 Gediplomeerd Gedragsconsultant</span>
                <span data-id="element-2760" data-mp="28ikj6i8ycqtt">🐾 Natural Dog Trainer Niveau 5</span>
                <span data-id="element-2761" data-mp="2maicpkq6ke4v">👥 15.000+ geholpen</span>
                <span data-id="element-2762" data-mp="2ia6qi3i665ra">⭐ 4,3 Trustpilot</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 14: IS THIS FOR YOU? */}
      <section className="py-16 md:py-20 px-5" data-id="element-2763" data-mp="2wa97lninkv5h">
        <div className="max-w-4xl mx-auto" data-id="element-2764" data-mp="2rbepknsifamf">
          <h2 className="text-3xl font-bold text-[#1a2b4a] text-center mb-10" data-id="element-2765" data-mp="2rcfz2ntvnp21">
            Is Liefdevol Communiceren iets voor jou?
          </h2>
          <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-2766" data-mp="3fvhr3k7xua1l">
            <div className="bg-red-50 rounded-2xl p-6 border border-red-100" data-id="element-2767" data-mp="3fuzw0qx0i1v9">
              <h3 className="font-bold text-[#1a2b4a] text-lg mb-4" data-id="element-2768" data-mp="30xpg95dc69tq">
                Dit is NIET voor jou als je…
              </h3>
              <ul className="space-y-3" data-id="element-2769" data-mp="35zeqiisqijgr">
                {['Vindt dat een hond "gewoon moet gehoorzamen" zonder uitleg', 'Liever straft dan begrijpt', 'Geen tijd wilt investeren in een echte verbinding'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-2770" data-mp="2i66aiqrxgho0" data-mpi={i}>
                    <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-2771" data-mp="2n7lx4n9r6w8i" />
                    <span className="text-gray-700" data-id="element-2772" data-mp="298dx5s5rnk39">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-green-50 rounded-2xl p-6 border border-green-100" data-id="element-2773" data-mp="2db0pdu6cn70z">
              <h3 className="font-bold text-[#1a2b4a] text-lg mb-4" data-id="element-2774" data-mp="264yallizqa6a">
                Dit is WEL voor jou als je…
              </h3>
              <ul className="space-y-3" data-id="element-2775" data-mp="1wfwwk0w0a2uy">
                {['Het beste met je hond voor hebt', 'Klaar bent met methoden die niet werken', 'Wilt samenwerken met je hond in plaats van commanderen', 'Die diepe, warme band wilt die je altijd al voor ogen had', 'Openstaat voor een nieuwe manier van kijken'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-2776" data-mp="1dg993le0w2u0" data-mpi={i}>
                    <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-2777" data-mp="18hzcd6cngu6a" />
                    <span className="text-gray-700" data-id="element-2778" data-mp="18kc2i6skaauf">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="text-center text-gray-600 italic max-w-2xl mx-auto" data-id="element-2779" data-mp="32xaagjqsgvel">
            "Ik had al veel geprobeerd en dacht dat ik al veel wist. Maar dit
            was een echte eyeopener. Je merkt nu pas hoeveel je uitgaat van
            praten in plaats van lichaamstaal." - Cursist met 12 jaar
            hondenervaring
          </p>
        </div>
      </section>

      {/* SECTION 15: GUARANTEE */}
      <section className="bg-[#faf5eb] py-16 md:py-20 px-5" data-id="element-2780" data-mp="3p3w7q8ckrbx7">
        <div className="max-w-xl mx-auto text-center" data-id="element-2781" data-mp="2sen6cwvnfmv3">
          <div className="w-24 h-24 mx-auto mb-6 bg-[#5ce0d2] rounded-full flex items-center justify-center" data-id="element-2782" data-mp="2sg81oopsf9u0">
            <ShieldIcon className="w-12 h-12 text-white" data-id="element-2783" data-mp="2whju1201q95w" />
          </div>
          <h2 className="text-3xl font-bold text-[#1a2b4a] mb-6" data-id="element-2784" data-mp="31d8o4ptaqxut">
            Probeer het 30 dagen volledig risicovrij
          </h2>
          <div className="text-lg text-gray-700 leading-relaxed space-y-4" data-id="element-2785" data-mp="gokwtgqspr0q">
            <p data-id="element-2786" data-mp="gqoxlptee9ws">
              Ik ben zo overtuigd van wat de Hondentaal Methode voor jou en je
              hond kan betekenen, dat ik je een volledige garantie geef.
            </p>
            <p data-id="element-2787" data-mp="3s3cvsj3nz06a">
              Volg de cursus. Pas de communicatievaardigheden toe. En als je na
              30 dagen niet het gevoel hebt dat je je hond beter begrijpt en dat
              jullie band sterker is geworden - dan krijg je je geld volledig
              terug.
            </p>
            <p className="font-bold text-[#1a2b4a]" data-id="element-2788" data-mp="zxvej1vz273">
              Geen vragen gesteld. Want ik wil alleen tevreden baasjes en
              gelukkige honden.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 16: FINAL CTA */}
      <section className="bg-[#e6f7f5] py-16 md:py-24 px-5" data-id="element-2789" data-mp="3j3zkrlzw63jg">
        <div className="max-w-2xl mx-auto text-center" data-id="element-2790" data-mp="3j5kfbbm7hmhb">
          <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] mb-6 leading-tight" data-id="element-2791" data-mp="3ed9co102zml2">
            Jouw hond praat de hele dag tegen je.
            <br data-id="element-2792" data-mp="2qlu801ku0t6n" />
            Het is tijd om hem te antwoorden.
          </h2>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-2793" data-mp="2lo2dr0wpsuza">
            Elke dag zijn er momenten van contact, van communicatie, van
            verbinding. Maar ook: momenten van frustratie en miscommunicatie.
            Die momenten hoeven er niet te zijn. Niet omdat je hond anders moet
            worden. Maar omdat jij zijn taal leert spreken.
          </p>
          <p className="text-gray-500 mb-8" data-id="element-2794" data-mp="w6ylds2yu038">
            Meer dan 15.000 baasjes gingen je al voor.
          </p>
          <PriceBlock data-id="element-2795" data-mp="1jyc9tmxzxbix" />
          <CTAButton className="text-xl py-5" data-id="element-2796" data-mp="1jy3xbw5sc889" />
          <TrustIcons data-id="element-2797" data-mp="1owxebyka6hd6" />
          <p className="text-sm italic text-gray-500 mt-8" data-id="element-2798" data-mp="1ovcfvxuuiea1">
            "We garanderen een blije baas en een blije hond - anders storten we
            liever het geld terug." - Amee de Bruijn, Stressless Dogs
          </p>
        </div>
      </section>

      {/* SECTION 17: FAQ */}
      <section className="py-16 md:py-20 px-5" data-id="element-2799" data-mp="3vmlqcql5slnr">
        <div className="max-w-3xl mx-auto" data-id="element-2800" data-mp="3voy5kvzj8hx4">
          <h2 className="text-3xl font-bold text-[#1a2b4a] text-center mb-10" data-id="element-2801" data-mp="3jklpm7vuqff">
            Veelgestelde vragen
          </h2>
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden px-6" data-id="element-2802" data-mp="v7f58d0xxe8j">
            <FAQItem q="Werkt dit ook als mijn hond al jarenlang hetzelfde gedrag vertoont?" a="Ja. De Hondentaal Methode gaat niet over het 'afleren' van gedrag - het gaat over het verbeteren van jullie communicatie. Honden zijn van nature sociale wezens die willen samenwerken. Ze wachten eigenlijk al op jou om hun taal te leren spreken." data-id="element-2803" data-mp="q5zkkm2od9qo" />
            <FAQItem q="Ik heb al cursussen gevolgd en trainers gehad. Wat maakt dit anders?" a="De meeste cursussen richten zich op het gedrag van de hond: wat hij moet doen en laten. Liefdevol Communiceren richt zich op iets fundamentelers: de taal die jullie gebruiken om met elkaar te communiceren. Dat is de basis van alles. Zonder die basis werkt geen enkele techniek duurzaam." data-id="element-2804" data-mp="19wl5837lr8hh" />
            <FAQItem q="Mijn hond is erg angstig of overprikkeld. Is dit dan ook geschikt?" a="Juist dan is deze cursus waardevol. Angstige en overprikkelde honden reageren het sterkst op de manier waarop jij communiceert. Als jij leert hun signalen te lezen en in hun taal te antwoorden, neemt de stress bij veel honden snel merkbaar af." data-id="element-2805" data-mp="1st32f05800l4" />
            <FAQItem q="Ik heb al meer dan 10 jaar honden. Is dit dan nog iets nieuws voor mij?" a='Veel van onze meest enthousiaste cursisten zijn ervaren hondeneigenaren. Zoals één van hen schreef: "Na 12 jaar een Golden Retriever gehad te hebben, was het toch nog erg leerzaam. Je merkt nu pas hoeveel je uitgaat van praten in plaats van lichaamstaal."' data-id="element-2806" data-mp="2e63b78xqu2s6" />
            <FAQItem q="Hoe lang heb ik toegang tot de cursus?" a="Levenslang en onbeperkt. Je kunt altijd terugkijken, herhalen, en de cursus opnieuw doorlopen als je een nieuwe hond krijgt of als je situatie verandert." data-id="element-2807" data-mp="2xrzq3j4h4mky" />
            <FAQItem q="Wanneer zie ik resultaat?" a="Veel cursisten zien al resultaat tijdens of direct na de eerste module. Dat komt omdat de Hondentaal Methode geen trucjes zijn die je moet inslijpen - het zijn communicatieprincipes die je hond van nature al begrijpt." data-id="element-2808" data-mp="fpt1hlnv20ht" />
            <FAQItem q="Is de cursus ook geschikt voor een puppy of een senior hond?" a="Absoluut. Bij een puppy help je problemen voorkomen voordat ze ontstaan. Bij een oudere hond verbeter je een relatie die al jaren bestaat - en dat is nooit te laat." data-id="element-2809" data-mp="uefg1l5nyo7z" />
            <FAQItem q="Kan ik ook betalen in termijnen?" a="Neem contact op via de website als je vragen hebt over betaalmogelijkheden. We denken graag met je mee." data-id="element-2810" data-mp="6obm65ia22u6" />
          </div>
        </div>
      </section>

      {/* SECTION 18: FOOTER CTA BAR */}
      <div className="bg-[#1a2b4a] py-6 px-5" data-id="element-2811" data-mp="1n2bht4a3b6bm">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-4 text-center" data-id="element-2812" data-mp="1n108koxvl6d4">
          <p className="text-white font-medium" data-id="element-2813" data-mp="37moqlfstsnhi">
            Klaar om de taal van je hond te leren spreken?
          </p>
          <a href={CHECKOUT_URL} className="bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-8 rounded-xl transition-colors shadow-md whitespace-nowrap" data-id="element-2814" data-mp="2xusprwzcuj9l">
            Ja, ik wil beginnen voor €127 →
          </a>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="bg-[#111827] text-gray-400 py-12 text-xs leading-relaxed text-center px-4" data-id="element-2815" data-mp="2jurpain05dun">
        <div className="max-w-5xl mx-auto space-y-6" data-id="element-2816" data-mp="2eveunbpw32hi">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-8 mx-auto mb-4 opacity-60" data-id="element-2817" data-mp="2eyavb7t4g59n" />
          <p data-id="element-2818" data-mp="85h0tje4dxcb">
            © Copyright Stressless Dogs | stresslessdogs.nl | Alle rechten
            voorbehouden
          </p>
          <p className="font-bold text-white" data-id="element-2819" data-mp="22ke41yk4aaez">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>
          <p data-id="element-2820" data-mp="1xm2ttmpwtxw8">
            vragen kun je altijd stellen door te mailen naar{' '}
            <a href="mailto:amee@stresslessdogs.nl" className="text-[#5ce0d2] hover:underline" data-id="element-2821" data-mp="2lcq4gfr7n1mh">
              amee@stresslessdogs.nl
            </a>
          </p>
        </div>
      </footer>
    </div>;
}